import(/* webpackMode: "eager" */ "/codebuild/output/src39902398/src/Camouflage-frontend/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src39902398/src/Camouflage-frontend/src/components/BackButton/BackButton.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src39902398/src/Camouflage-frontend/src/components/CustomLink/CustomNavLink.tsx");
